<button class="back-button" mat-flat-button (click)="clicked()">
    <mat-icon [svgIcon]="icon || 'chevron-double-left'"></mat-icon>
    {{ text || 'Back to List'}}
</button>